import type { HTMLProps, ReactNode } from 'react'

import cx from 'classnames'
import { useContext, useEffect } from 'react'

import styles from './card.module.css'
import { CardContext } from './context'

interface ExpandWrapperProps extends HTMLProps<HTMLDivElement>{
  children: ReactNode
  open?: boolean

  onOpenChange?: (value: boolean) => void
}

export function ExpandableWrapper ({ children, open, onOpenChange, ...rest }: ExpandWrapperProps): JSX.Element {
  const cardContext = useContext(CardContext)

  const isCardOpen = typeof open === 'boolean'
    ? open
    : typeof cardContext?.open === 'boolean'
      ? cardContext.open
      : true

  useEffect(() => {
    onOpenChange?.(cardContext.open)
  }, [ cardContext.open, onOpenChange ])

  return (
    <div
      className={cx(styles.expandableWrapper, {
        [styles.open as string]: isCardOpen
      })}
      {...rest}
    >
      {children}
    </div>
  )
}
